import { URLs } from './../enums/urls.enum';
import { LangCodes } from './../enums/lang-codes.enum';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable ,  of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable()
export class RoomsService {

  constructor(private httpClient: HttpClient) { }

  getRooms(lang:string): Observable<string> {
    return this.httpClient
      .get(lang == LangCodes.spanish ? URLs.urlSpanish : URLs.urlEnglish)
      .pipe(
        map((body: any) => body),
        catchError(() => of('Error, could not load joke :-('))
      );
  }

}

